module.exports = __webpack_public_path__ + "img/春节大促_34.eba187a5.png";